export default "__VITE_ASSET__VX9sE62M__"